// src/mixins/orderMixin.js
import { mapGetters, mapActions } from "vuex";
// import Toast from "path-to-toast"; // Import Toast appropriately

export default {
  methods: {
    ...mapActions("loading", ["done"]),
    ...mapGetters("storeInfo", ["configs"]),
    async handlerCompleteOrder(checkoutData, paymentIntentId) {
      let form = new Form({ ...checkoutData, paymentIntentId });
      try {
        const { data } = await form.post("/app/orders/cart/checkoutV4");

        switch (true) {
          case data.status === "Success" || data.status === "accept":
            await this.cleanShoppingCart();
            if (this.configs.redirectThanksUrl) {
              await this.$router.push({
                name: "Redirect",
                params: {
                  url: this.configs.redirectThanksUrl,
                },
              });
            } else {
              await this.$router.push({
                name: "Thanks",
                params: { orderref: data.data.orderRef },
              });
            }

            Toast.fire({
              icon: "success",
              title: data.message,
            });
            break;
          case data.status === "false":
            Swal.fire({
              icon: "error",
              title: this.$t("errors.error_alert_title"),
              text: data.data.message,
              reverseButtons: true,
              confirmButtonText: "ok",
            });
            await this.done();
            break;
          default:
            Swal.fire({
              icon: "error",
              title: this.$t("errors.error_alert_title"),
              text: data.data.message,
              reverseButtons: true,
              confirmButtonText: "ok",
            });
            await this.done();
            break;
        }
      } catch (e) {
        if (e.response && e.response.data && e.response.data.message) {
          const msg = e.response.data.message.toUpperCase();
          let errorMsg;
          switch (msg) {
            case "ALREADY_EXIST":
              errorMsg = this.$t("errors.ALREADY_EXIST");
              break;
            case "NOT_VALIDATED_YET":
            case "VALIDATED_TYPE_NOT_SAME":
            case "PAYMENT_FAILED":
              errorMsg = this.$t("errors.NOT_VALIDATED_YET");
              break;
            case "DELIVERY_PARTNER_DECLINED":
              errorMsg = this.$t("errors.DELIVERY_PARTNER_DECLINED");
              break;
            case "SAVE_ORDER_FAILED":
              errorMsg = this.$t("errors.SAVE_ORDER_FAILED");
              break;
            case "PRODUCT_NOT_AVAILABLE_FOR_ORDER_YET":
              errorMsg = this.$t("errors.PRODUCT_NOT_AVAILABLE_FOR_ORDER_YET");
              break;
            case "PRODUCT_REQUIRES_SPECIFIC_DATE":
              errorMsg = this.$t("errors.PRODUCT_REQUIRES_SPECIFIC_DATE");
              break;
            case "PRODUCTS_REQUIRE_DIFFERENT_DATES":
              errorMsg = this.$t("errors.PRODUCTS_REQUIRE_DIFFERENT_DATES");
              break;
            default:
              errorMsg = this.$t("errors.COMMON_ERROR");
              break;
          }
          Swal.fire({
            icon: "error",
            title: this.$t("errors.error_alert_title"),
            text: errorMsg,
            confirmButtonText: "Ok",
            showCloseButton: true,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: this.$t("errors.error_alert_title"),
            text: this.$t("errors.COMMON_ERROR"),
            confirmButtonText: "Ok",
            showCloseButton: true,
          });
        }
        await this.done();
      }
    },
    async cleanShoppingCart() {
      await this.$router.push({ name: "Discovery" });
      this.$store.dispatch("guest/removeInfo");
      this.$store.dispatch("delivery/removeDeliveryDetails");
      this.$store.dispatch("delivery/removeDeliveryMethod");
      this.$store.dispatch("guest/removeAddress");
      this.$store.dispatch("guest/removeSessionId");
      this.$store.dispatch("checkout/setTotal", 0);
      this.$store.dispatch("cart/deleteDetails");
      // this.$store.dispatch("checkout/loadDeliveryServices");
      this.$store.dispatch("customer/removeOption");
      this.$store.dispatch("delivery/setOptionDoor", false);
      this.$store.dispatch("checkout/setFlatPayCheckoutData", {
        paymentType: null,
        fp_id: null,
        url: null,
        checkoutData: null,
      });
      this.$store.dispatch("checkout/setAddFlatPayMethod", false);
      localStorage.removeItem("flatPayCheckoutData");
      localStorage.removeItem("isNewFlatPayMethod");
    },
  },
};
